// hooks
import useAuth from '../hooks/useAuth';
// utils
import createAvatar from '../utils/createAvatar';
//
import Avatar, { Props as AvatarProps } from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }: AvatarProps) {
  const { user } = useAuth();

  return (
    <Avatar
      src={user?.account?.photoURL}
      alt={user?.account?.displayName}
      color={user?.account?.photoURL ? 'default' : createAvatar(user?.account?.displayName).color}
      {...other}
    >
      {createAvatar(user?.account?.displayName).name}
    </Avatar>
  );
}
